/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CallidusBoatCountryRegistered {
    Aut = 'Aut',
    Ger = 'Ger',
    Cro = 'Cro',
    Slo = 'Slo'
  }

    export const CallidusBoatCountryRegisteredTranslocoMap: Record<CallidusBoatCountryRegistered, string> = {
    [CallidusBoatCountryRegistered.Aut]: 'callidusBoatCountryRegistered.aut',
    [CallidusBoatCountryRegistered.Ger]: 'callidusBoatCountryRegistered.ger',
    [CallidusBoatCountryRegistered.Cro]: 'callidusBoatCountryRegistered.cro',
    [CallidusBoatCountryRegistered.Slo]: 'callidusBoatCountryRegistered.slo',
    };

    export const CallidusBoatCountryRegisteredOptions = [
  { value: CallidusBoatCountryRegistered.Aut, labelKey: 'callidusBoatCountryRegistered.aut' },
  { value: CallidusBoatCountryRegistered.Ger, labelKey: 'callidusBoatCountryRegistered.ger' },
  { value: CallidusBoatCountryRegistered.Cro, labelKey: 'callidusBoatCountryRegistered.cro' },
  { value: CallidusBoatCountryRegistered.Slo, labelKey: 'callidusBoatCountryRegistered.slo' },
    ];

